<template>
  <div>
    <div
      id="banner"
      v-bind:style="{
        'background-image':
          'linear-gradient(0deg, rgba(30, 32, 38, 0.7),rgba(30, 32, 38, 0.7)),' +
          'url(' +
          '//' +
          this.url +
          this.download_url +
          ')',
      }"
    >
      <news v-if="this.news.length > 0" :news="this.news"></news>
    </div>
    <abstract
      :abstract_data="{
        text: this.page.abstract,
        image: this.page.abstract_image.id,
      }"
    ></abstract>
    <projects :projects="this.projects"></projects>
  </div>
</template>

<script>
import Abstract from "@/components/Abstract.vue";
import Projects from "@/components/Projects.vue";
import News from "@/components/News.vue";
import { getWagtailImage, getLatestData } from "@/api";

export default {
  name: "Home",
  props: ["page"],
  components: {
    Abstract,
    Projects,
    News,
  },
  data() {
    return {
      download_url: "",
      url: "",
      projects: [],
      news: [],
    };
  },
  created() {
    if (this.page.banner_image != null)
      getWagtailImage(this.page.banner_image.id).then((response) => {
        const image = response.data;
        this.download_url = image.meta.download_url;
      });
    this.url = process.env.VUE_APP_API_URL;

    getLatestData("news", { limit: 5, breast: 1 }).then((response) => {
      this.news = response.data;
    });

    getLatestData("projects", { limit: 4, active_only: 1, breast: 1 }).then(
      (response) => {
        this.projects = response.data;
      }
    );
  },
};
</script>

<style lang="scss">
#banner {
  height: min-content;
  background-image: linear-gradient(
      0deg,
      rgba(30, 32, 38, 0.7),
      rgba(30, 32, 38, 0.7)
    ),
    url("../assets/banner-default.jpg");
  background-size: cover;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
